import React from 'react';
import {connect} from 'react-redux';

class Loader extends React.Component{

  render(){

    return (

      <span>
      { this.props.loader.loader ? <div className="container background-light loader-div">  
        <div className="loader-inner-box">

          <div className="spinner">

          </div>
        </div>
      </div> : <span/>

       }
     </span>
  )
}

}



function mapStateToProps(state) {
  return {
    loader : state.Loader,
  };
}


export default connect(mapStateToProps)(Loader);



// WEBPACK FOOTER //
// ./src/components/Loader/loader.js